import { types, getRoot } from "mobx-state-tree"
import { io } from "socket.io-client"
import AppConfigService from "../../services/app_config_service"

const config = AppConfigService.getConfig()

const SocketStore = types
  .model("SocketStore", {})
  .volatile(() => ({
    socket: undefined,
  }))
  .views((self) => {
    return {}
  })
  .actions((self) => {
    return {
      initializeSocket() {
        const userId = getRoot(self).sessionStore?.userId
        if (userId) {
          self.socket = io(config.API_SOCKET, {
            reconnectionAttempts: 5,
            reconnectionDelay: 3000,
            extraHeaders: {
              Authorization: `Basic ${config.API_TOKEN}`,
            },
            query: {
              user_id: userId,
            },
          })

          self.socket.on("reconnect_failed", () => {
            getRoot(self).uiStore.openNotification(
              "cannot connect to websocket",
              "error"
            )
          })
        }
      },
    }
  })

export default SocketStore
